// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2815536c","551":"81079abb","849":"6284f677","851":"fc76b445"}[chunkId] + ".chunk.js";
};